$(document).ready(function() {
  var decsmarteditbanner = '#smarteditoverlay smartedit-element[data-smartedit-component-id*=\'productList\']';

  if ($(decsmarteditbanner).length > 0) {
    setTimeout(function() {
      $(decsmarteditbanner).css({
        left: '10px',
        'max-width': '95vw'
      });
    }, 3000);
  }
});
